import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage, t } from './i18n';
import { useAuth } from './VrAuthContext';
import LanguagePicker from './LanguagePicker';

export default function NavigationBar({ onOpenAuth }) {
  useLanguage();
  const { currentUser, userProfile, isAdmin, logout, loading } = useAuth();
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const header = useRef(null), toggle = useRef(null), menu = useRef(null);
  useEffect(() => { setMenuOpen(false); }, [pathname]);
  useEffect(() => {
    if (!menuOpen) return;
    menu.current?.querySelector('a')?.focus({ preventScroll: true });
    const outside = event => { if (!header.current?.contains(event.target)) setMenuOpen(false); };
    const escape = event => {
      if (event.key === 'Escape') { setMenuOpen(false); toggle.current?.focus({ preventScroll: true }); }
    };
    document.addEventListener('pointerdown', outside); document.addEventListener('keydown', escape);
    return () => { document.removeEventListener('pointerdown', outside); document.removeEventListener('keydown', escape); };
  }, [menuOpen]);
  const close = () => setMenuOpen(false);
  return <header className="app-header" ref={header}>
    <nav className="navbar" aria-label={t('Navegación principal')}>
      <Link to="/" className="brand-link" onClick={close}>
        <div className="brand-title"><img src="/scene-share-icon.png" alt="" className="portal-brand-icon"/> SCENE SHARE <span>XR</span></div>
      </Link>
      <LanguagePicker onOpen={close} closeWhen={menuOpen}/>
      <button ref={toggle} type="button" className="mobile-menu-toggle" aria-label={t(menuOpen ? 'Cerrar menú' : 'Abrir menú')} aria-expanded={menuOpen} aria-controls="site-navigation" onClick={() => setMenuOpen(value => !value)}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true"><path d={menuOpen ? 'M6 6l12 12M6 18 18 6' : 'M4 6h16M4 12h16M4 18h16'}/></svg>
      </button>
      <div ref={menu} id="site-navigation" className={`nav-menu${menuOpen ? ' is-open' : ''}`} onBlur={event => { if (event.relatedTarget && !header.current?.contains(event.relatedTarget)) close(); }}>
        <ul className="nav-links">
          <li><Link to="/" aria-current={pathname === '/' ? 'page' : undefined} onClick={close}>{t('Home')}</Link></li>
          <li><Link to="/models" aria-current={pathname.startsWith('/models') ? 'page' : undefined} onClick={close}>{t('Modelos 3D & VR')}</Link></li>
          {currentUser && <li><Link to="/media" aria-current={pathname.startsWith('/media')?'page':undefined} onClick={close}>{t('Galería multimedia')}</Link></li>}
          {isAdmin && <li><Link to="/admin" aria-current={pathname.startsWith('/admin') ? 'page' : undefined} onClick={close}>{t('Administración')}</Link></li>}
          <li className="nav-account">{currentUser ? <div className="nav-account-content">
            <span className="nav-user">{userProfile?.displayName || currentUser.displayName || currentUser.email}{userProfile?.inviteCode && <span className="nav-user-id"> {t('(ID:')} <strong>{userProfile.inviteCode}</strong>)</span>}</span>
            <button type="button" className="btn-jar-outline" onClick={async () => { await logout(); close(); }}>{t('Salir')}</button>
          </div> : loading ? <span role="status">{t('Cargando cuenta…')}</span> : <button id="nav-login" type="button" className="btn-jar-primary" onClick={() => { close(); onOpenAuth(); }}>{t('Acceder / Registro')}</button>}</li>
        </ul>
      </div>
    </nav>
  </header>;
}
